import UploadProgress from './upload-progress.vue';
import Vue from 'vue'

const Profile = Vue.extend(UploadProgress);

const ossProgress = {};

ossProgress.show = function () {
  const ProfileComponent = new Profile().$mount();
  const el = ProfileComponent.$el;
  document.body.appendChild(el);

  ossProgress.hide = function () {
    document.body.removeChild(el);
    ProfileComponent.$destroy();
  }

  ossProgress.progress = ProfileComponent.receiveProgress;
}

export default ossProgress;



// WEBPACK FOOTER //
// ./src/untils/upload-progress/index.js